import React from "react";
import "./ExamPrep.css";

const C2ExamPrep = () => {
  return (
    <div className="a1ExamPrepCover">
      <h3>
        Goethe <span>C2 Exam</span> Preparation
      </h3>
      <p>C2 is considered to be near-native level. To prepare for it: </p>
      <ul>
        <li>
        Advance your vocabulary across various fields. Develop a deep
          understanding of complex grammar structures and sentence
          constructions.
        </li>
        <li>
        Read demanding texts, such as academic papers, literature, or
          professional articles.
        </li>
        <li>
        Produce sophisticated essays, research papers, or formal reports on
          diverse and challenging topics.
        </li>
      </ul>
    </div>
  );
};

export default C2ExamPrep;
